export const headers = [
  { field: "id", headerName: "ID", hidden: true },
  { field: "nombre", headerName: "Nombre", minWidth: 200 },
];
